import Table from '../components/shared/table';
import SalesOrderData from '../model/sales-order-data';
import AbstractAsyncTablePage from './abstract-async-table-page';
import { getParameterByName } from '../helpers/utils';
import MessageHelper from '../helpers/message-helper';

export default abstract class AbstractAsyncDetailTablePage<T> extends AbstractAsyncTablePage {

  protected abstract detailTableTemplate: JQuery<HTMLTemplateElement>;
  protected abstract detailTableColumnDefinitions: DataTables.ColumnDefsSettings[];

  protected bindShowDetails(): void {
    $('table').on('click', 'td.js-showDetails', (e) => {
      const tr = $(e.target).closest('tr');
      this.toggleDetails(tr);
    });
  }

  protected abstract getDetailUrl(parent: T): string;

  protected toggleDetails(tr: JQuery<HTMLTableRowElement>, forceShow = false): void {
    const row = this.table.getInstance().row(tr);
    const rowData = row.data() as unknown as T;

    if (row.child.isShown() && !forceShow) {
      row.child.hide();
      tr.removeClass('-child-shown');
    } else {
      const childTableElement = $(this.detailTableTemplate.html());
      const childRow = row.child(childTableElement);
      childRow.show();
      this.createDetailTable(childTableElement.children().first(), rowData);
      tr.addClass('-child-shown');
    }
  }

  protected generateDrawCallback = (idName: string) => (settings: DataTables.SettingsLegacy): void => {
    const datatable = Table.getInstance(settings);
    const selectedId = getParameterByName(idName);
    if (selectedId) {
      const row = datatable.row(0);
      if (row.data() && !row.child.isShown()) {
        this.toggleDetails($(row.node() as HTMLTableRowElement), true);
      }
    }
  };

  protected createDetailTable(container: JQuery, rowData: T): Table {
    const url = this.getDetailUrl(rowData);
    const detailTable = Table.init(container, this.detailTableColumnDefinitions, {
      ajax: {
        url,
        dataSrc: (data: SalesOrderData) => data.entries,
        error: () => {
          window.NotificationHelper.showError(MessageHelper.getMessage('eparts.sap.file.search.service.error'));
        },
      },
    });
    return detailTable;
  }
}
